<template>
    <div>
        <van-field v-model="title" disabled/>
        <van-radio-group v-model="radio">
            <van-cell-group>
                <van-cell title="男" clickable>
                    <van-radio name="1" />
                </van-cell>
                <van-cell title="女" clickable>
                    <van-radio name="2" />
                </van-cell>
            </van-cell-group>
        </van-radio-group>
        <div class="icons">
            <button type="button" class="past" @click="past">上一题</button>
            <button type="button" @click="next">下一题</button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title: '1.您的性别是什么？',
                radio: ''
            }
        },
        methods: {
            past() {
                this.$router.push({
                    path: '/user/subject?no=1'
                });
            },
            next() {
                this.$router.push({
                    path: '/user/GXHTC'
                });
            }
        }
    }
</script>


<style scoped lang="less">
body{
    background-color: #fff;
}
    .icons {
        position: fixed;
        bottom: 0;
        text-align: center;
        width: 100%;
        // margin-top: 2rem;
        i {
            color: #619534;
            font-size: 1.2rem;
        }
        button {
            margin: 0 1rem;
            background: inherit;
            background-color: #aacd06;
            box-sizing: border-box;
            border-width: 1px;
            border-style: solid;
            border-radius: 6px;
            box-shadow: none;
            text-align: center;
            font-size: 0.8em;
            height: 2.5rem;
            width: 30%;
            color: #fff;
            border-color: #aacd06; // position: absolute;
        }
        .past {
            color: #aacd06;
            border-color: #aacd06;
            background-color: #fff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/subject.vue